// Lista de roles aceptados en addon manager user
export const MANAGE_USERS_ROLES = {
  manager: {
    label: 'Manager horeca',
    value: 'horeca_manager'
  }
}
